import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    MenuData: [],
    userInfo: [],
    // 数据字典
    treeList: [],//数据字典集合
    itemid: '',//字典分类ID
    sysTreeList: [],// 功能目录
    GetspecialtynList: {},// 专业目录
  },
  mutations: {
    setMenuData: (state, menuData) => {

    },
    SET_ACCOUNT (state, platform) {
      state.userInfo = platform;
    },
  },
  actions: {
    setAccount ({ commit }, platform) {
      commit('SET_ACCOUNT', platform);
    },
  },
  getters: {
    getuserInfo: (state) => state.userInfo,
  },
  modules: {
  }
})
